import { withChoreographedRender } from '@atlassian/jira-choreographer-services/src/withChoreographedRender.tsx';
import CommonFlag from './common-flag.tsx';
import type { CommonFlagProps } from './types.tsx';

export const ChoreographerCommonFlag = withChoreographedRender<CommonFlagProps>(CommonFlag);
